import { NGXAjax } from '../../common/Services/AjaxService.js';
import { resolve, reject } from './util/api-util';

function fetchRealTimeVotes(containerRef) {
  return NGXAjax.get(
    `${App.globalContext.cronosURLSecure}/api/metric/cgroup.json?apikey=${
      App.globalContext.account.apikey
    }&containerRef=${containerRef}&order=desc`
  ).then(resolve, reject);
}

export { fetchRealTimeVotes };
